
import { SHA256 } from "crypto-js";

import { defineComponent } from "vue";
export default defineComponent({
  data() {
    return {
      password: "",
      saved: localStorage.getItem('password'),
    };
  },
  methods:{
    login(){
      localStorage.setItem('password', SHA256(this.password).toString());
      location.reload();
    },
  }
});
